/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	itemContainerStyle: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},

	indentedItemContainerStyle: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.500'),
	},

	iconContainerStyle: {
		paddingTop: token('space.025'),
	},

	textContainerStyle: {
		display: 'block',
		paddingLeft: token('space.150'),
	},

	titleStyle: {
		fontWeight: token('font.weight.bold'),
		paddingBottom: token('space.025'),
		color: token('color.text'),
	},
});

type SettingItemProps = {
	icon: JSX.Element;
	title: string;
	description?: string;
	defaultValue: boolean;
	toggle: () => void;
	indented?: boolean;
	display?: boolean;
};

export const SettingItem = (props: SettingItemProps) => {
	const { icon, title, description, toggle, defaultValue, indented, display } = props;

	return display ? (
		<Inline
			spread="space-between"
			alignBlock="center"
			xcss={indented ? styles.indentedItemContainerStyle : styles.itemContainerStyle}
		>
			<Inline>
				<Inline xcss={styles.iconContainerStyle}>{icon}</Inline>
				<Inline xcss={styles.textContainerStyle}>
					<Inline xcss={styles.titleStyle}>{title}</Inline>
					{description && <Text color="color.text.subtle">{description}</Text>}
				</Inline>
			</Inline>
			<Toggle id="toggle-default" onChange={toggle} defaultChecked={defaultValue} />
		</Inline>
	) : null;
};
